import type { FaireProductEntity } from "../../entity_types/product";

export const p_awzan4hnpa: FaireProductEntity = {
  token: "p_awzan4hnpa",
  type: "product",
  name: 'Wide Base Mug with Sun-3.5"H(14oz)',
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.faire.com/fastly/def257fe245bd11dc2ec57abdef7dfa2d91e8b61374b2081c679da14b55f09f8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4094828314d4c63d2530a67cfdbcb3d52bc3bdf4e1ba88524b43bb7f23fae342.jpeg",
  ],
  priceDollars: 5,
  description:
    "Introducing our Wide Base Mug with a Sun design. This generously sized, 14oz mug features a sturdy wide base for stability and a radiant sun illustration, bringing warmth and cheer to your morning routine. Perfect for enjoying your favorite hot beverages, it combines functionality with an elegant design.",
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:16.696Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
